import { LitElement, html, svg } from 'lit';

export class IconMessages16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2 1h12a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H7.5L4 15v-3H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1ZM12 5H4M9 8H4"></path></svg>`; }
}
if (!customElements.get('f-icon-messages16', IconMessages16)) {
  customElements.define('f-icon-messages16', IconMessages16);
}